<div class="main-content table-page table-page--compact admin-proyectos-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Administración de Proyectos</h1>
        <p>Administre el portafolio, áreas y clientes desde una sola vista operativa.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="openAddProyecto()">
        <i class="material-icons">add</i>
        <span>Agregar Proyecto</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--wide table-page__field">
            <mat-label>Proyecto</mat-label>
            <input matInput type="text" maxlength="200" autocomplete="off" [(ngModel)]="nomProyecto"
              (keyup)="consultarProyectos(1)" aria-label="Proyecto" />
            <button *ngIf="nomProyecto" type="button" matSuffix mat-icon-button (click)="clearNombrePro()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
            <mat-label>Cliente</mat-label>
            <mat-select [(ngModel)]="clientefl" (ngModelChange)="consultarProyectos(1)">
              <mat-option>
                <ngx-mat-select-search [formControl]="formCliente" [placeholderLabel]="'Buscar cliente'"
                  [noEntriesFoundLabel]="'No existe cliente'">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let item of listaClientes" [value]="item.razonsocial">
                {{ item.razonsocial }}
              </mat-option>
            </mat-select>
            <button *ngIf="clientefl" type="button" matSuffix mat-icon-button (click)="clearNombreCli()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="tipoFl" (selectionChange)="onTipoChange()">
              <mat-option value="">Todos</mat-option>
              <mat-option value="PROYECTO">Proyecto</mat-option>
              <mat-option value="SERVICIO">Servicio</mat-option>
            </mat-select>
            <button *ngIf="tipoFl" type="button" matSuffix mat-icon-button (click)="clearTipo()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
            <mat-label>Estatus</mat-label>
            <mat-select [(ngModel)]="estatusFl" (selectionChange)="onEstatusChange()">
              <mat-option value="">Todos</mat-option>
              <mat-option value="ACTIVO">Activo</mat-option>
              <mat-option value="PAUSADO">Pausado</mat-option>
              <mat-option value="CERRADO">Cerrado</mat-option>
            </mat-select>
            <button *ngIf="estatusFl" type="button" matSuffix mat-icon-button (click)="clearEstatus()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
            <mat-label>Área</mat-label>
            <mat-select [(ngModel)]="selectArea" (selectionChange)="getArea($event.value)">
              <mat-option>
                <ngx-mat-select-search [formControl]="formArea" [placeholderLabel]="'Buscar área'"
                  [noEntriesFoundLabel]="'No existe área'">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let areaItem of (filterArea | async)" [value]="areaItem">
                {{ areaItem.area }}
              </mat-option>
            </mat-select>
            <button *ngIf="selectArea" type="button" matSuffix mat-icon-button (click)="clearArea()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="projects.length > 0; else proyectosEmptyState">
          <thead>
            <tr>
              <th>Proyecto</th>
              <th>Clasificación</th>
              <th>Cliente / Líder</th>
              <th>Fechas</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let proyecto of projects">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ proyecto.nombre || "Sin nombre" }}</strong>
                  <span class="table-page__subtext">
                    {{ getProjectIdentifier(proyecto) }} · {{ getProjectShortName(proyecto) }}
                  </span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__status-badge" [ngClass]="getProjectTypeClass(proyecto)">
                    {{ getProjectTypeLabel(proyecto) }}
                  </span>
                  <span class="table-page__subtext">{{ proyecto.nomArea || "Sin área asignada" }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ proyecto.nombreCliente || "Sin cliente" }}</span>
                  <span class="table-page__subtext">{{ getLeaderName(proyecto) }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ getDateRangeLabel(proyecto) }}</span>
                  <span class="table-page__subtext">Inicio / fin planeado</span>
                </div>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" matTooltip="Editar proyecto"
                  (click)="openModProyecto(proyecto)">
                  <i class="material-icons">edit</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #proyectosEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else proyectosLoadingState">
            <i class="material-icons">folder_off</i>
            <strong>No se encontraron proyectos</strong>
            <span>Ajusta los filtros o registra un proyecto nuevo desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #proyectosLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando proyectos...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} proyectos</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()"
            [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else adminProyectosPagerEllipsis" type="button"
              class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #adminProyectosPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()"
            [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()"
            [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
